export default __webpack_public_path__ + "img/map.bb179fe4.jpg";